var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button",on:{"click":_vm.click}},[_c('span',{class:_vm.$actual},[_vm._v(" "+_vm._s(_vm.text)+" ")]),(_vm.actual)?_c('div',{staticClass:"button__divider"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }